import React from 'react';
import styled from 'styled-components/macro';
import Slider from './Slider';
import { Card as CardV2 } from '../v2/components/card/Card';
import { cmsImageResize } from '../helpers';
import { connect } from 'react-redux';
import { fetchSideNav } from '../actions';

function RecommendedCardRow({
  className,
  strings,
  gridType,
  progNow,
  extraFeeds,
  heroCards,
  isSideNavToggled,
}) {
  const sliderClass = className ? className.toLowerCase() : '';
  let slidesToScrollDefault = 9;
  let slidesToShowDefault = 9;
  let responsiveSettings = [
    { breakpoint: 475, settings: { slidesToScroll: 2, slidesToShow: 2 } },
    { breakpoint: 716, settings: { slidesToScroll: 3, slidesToShow: 3 } },
    { breakpoint: 1140, settings: { slidesToScroll: 4, slidesToShow: 4 } },
    { breakpoint: 1829, settings: { slidesToScroll: 5, slidesToShow: 5 } },
    { breakpoint: 2077, settings: { slidesToScroll: 6, slidesToShow: 6 } },
    { breakpoint: 2325, settings: { slidesToScroll: 7, slidesToShow: 7 } },
    { breakpoint: 2573, settings: { slidesToScroll: 8, slidesToShow: 8 } },
  ];

  const d = new Date(
    new Date().toJSON().toLocaleString('en-GB', { timeZone: 'Europe/London' })
  );

  const nowInMins =
    parseInt(d.getHours(), 10) * 60 + parseInt(d.getMinutes(), 10);
  const endInMins =
    parseInt(progNow.end_txhour24, 10) * 60 + parseInt(progNow.end_txmin, 10);
  const timeLeft = endInMins - nowInMins;
  const nowLength =
    endInMins -
    parseInt(progNow.start_txhour24, 10) * 60 +
    parseInt(progNow.start_txmin, 10);
  const runTime = (100 / nowLength) * (nowLength - timeLeft);

  const progNowTitle =
    progNow.series_title === null || progNow.series_title === ''
      ? progNow.programme_title
      : progNow.programme_title === null || progNow.programme_title === ''
      ? progNow.series_title
      : progNow.series_title + ' - ' + progNow.programme_title;

  const subtitle = (key) =>
    extraFeeds[key].hide_link
      ? extraFeeds[key].hide_link_text
      : extraFeeds[key].time_text;

  return (
    <CardRow navClosed={!isSideNavToggled}>
      {progNow && extraFeeds && heroCards && (
        <Slider
          className={sliderClass + ' card-slick ' + (gridType ? gridType : '')}
          slidesToScrollDefault={slidesToScrollDefault}
          slidesToShowDefault={slidesToShowDefault}
          responsiveSettings={responsiveSettings}
          strings={strings}
        >
          {progNow && (
            <CardV2
              image={`https://www.s4c.cymru/amg/landscape/320x180/${progNow.thumbnail_url}`}
              isLive={true}
              subtitle={`${progNow.start_txhour24}.${progNow.start_txmin} - ${progNow.end_txhour24}.${progNow.end_txmin}`}
              title={progNowTitle}
              url="/Live"
              isSlick={true}
              progress={runTime}
              altText={
                progNow.image_alt_tag
                  ? progNow.image_alt_tag
                  : progNow.series_title
              }
              strings={strings}
            />
          )}
          {Object.keys(extraFeeds).map((key) => (
            <CardV2
              tag={strings.onlineExclusive}
              key={key}
              index={key}
              image={cmsImageResize(extraFeeds[key].image, '320x180')}
              isLive={!extraFeeds[key].hide_link}
              onLater={extraFeeds[key].hide_link}
              subtitle={
                extraFeeds[key].catch_up ? strings.catchUp : subtitle(key)
              }
              title={extraFeeds[key].title}
              url={`/Live/${extraFeeds[key].url}`}
              isSlick={true}
              altText={extraFeeds[key].title}
              strings={strings}
              isOECatchUp={extraFeeds[key].catch_up}
            />
          ))}
          {Object.keys(heroCards)
            .splice(1)
            .map((key) => (
              <CardV2
                key={key}
                index={key}
                image={cmsImageResize(heroCards[key].primary_media, '320x180')}
                subtitle={heroCards[key].subheading}
                title={heroCards[key].title}
                url={heroCards[key].entered_url}
                isSlick={true}
                altText={heroCards[key].title}
              />
            ))}
        </Slider>
      )}
    </CardRow>
  );
}

const CardRow = styled.div`
  max-width: 1240px;
  @media screen and (min-width: 1830px) {
    max-width: 1488px;
  }
  @media screen and (min-width: 2078px) {
    max-width: 1736px;
  }
  @media screen and (min-width: 2326px) {
    max-width: 1984px;
  }
  @media screen and (min-width: 2574px) {
    max-width: 2232px;
  }
  ${(props) =>
    props.navClosed &&
    `
    max-width: 1488px;
    @media screen and (min-width: 1830px) {
      max-width: 1736px;
    }
    @media screen and (min-width: 2078px) {
      max-width: 1984px;
    }
    @media screen and (min-width: 2326px) {
      max-width: 2232px;
    }
    @media screen and (min-width: 2574px) {
      max-width: 2480px;
    }
  `};
`;

function mapStateToProps(state) {
  return {
    isSideNavToggled: state.sideNav,
  };
}

export default connect(mapStateToProps, { fetchSideNav })(RecommendedCardRow);
